// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* You can add global styles to this file, and also import other style files */
/*** Color Variables *****/
.footer-section {
  background: #0c1a38;
  padding: 0px 0px 80px 0px;
}
.footer-section .footer-listing {
  border-bottom: 1px solid #566075;
  margin-bottom: 60px;
}
.footer-section .footer-listing [nz-col] {
  padding: 36px 0px 36px 0px;
}
.footer-section .footer-listing .footer_toggle_options [nz-col] {
  padding: 0px 0px 36px 0px;
}

.footer-top {
  padding: 80px 0px;
  background-color: #4cb8ac;
}
.footer-top .line-heading {
  position: relative;
}
.footer-top .line-heading h4 {
  font-size: 26px;
  font-weight: 300;
  margin: 0px 0px 10px 0px;
  color: #fff;
  display: block;
  line-height: 39px;
}
.footer-top .line-heading h4 span {
  font-weight: 500;
}
.footer-top .line-heading p {
  color: #fff;
  font-size: 18px;
  font-weight: 300;
  letter-spacing: -0.23px;
  margin-bottom: 0px;
  line-height: 27px;
}
.footer-top .ant-btn {
  float: right;
  font-size: 14px;
  font-weight: 600;
  color: #4cb8ac;
  text-align: center;
  letter-spacing: 1px;
  padding: 12px 55px;
  height: auto;
  border-radius: 35px;
  margin-top: 15px;
  text-transform: uppercase;
  border-color: transparent;
  line-height: 22px;
}
.footer-top .ant-btn:hover {
  background-color: #4cb8ac;
  color: #fff;
  border-color: #fff;
}

.footer-x-space {
  padding: 0px 100px;
}

.footer-bottom .footer-logo {
  display: block;
  margin-bottom: 40px;
}
.footer-bottom .footer-logo img {
  display: block;
  width: 126px;
  height: auto;
}
.footer-bottom h4 {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 42px;
}
.footer-bottom .app-col .app-col-inn {
  border: 1px solid #566075;
  padding: 32px 40px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -70px;
}
.footer-bottom .app-col .app-col-inn h4 {
  font-size: 20px;
  line-height: 48px;
  font-weight: 500;
  margin: 0;
  text-transform: uppercase;
}
.footer-bottom .app-col .app-col-inn .app-icon img {
  margin: 0 0 0 16px;
  height: 48px;
}
.footer-bottom .app-col .app-col-inn .app-icon img:first-child {
  margin: 0;
}
.footer-bottom .app-col p {
  font-size: 18px !important;
  font-weight: 300;
  line-height: 1.33;
  color: rgba(255, 255, 255, 0.59);
  padding-right: 50px;
  margin-bottom: 16px !important;
}
.footer-bottom .app-col img {
  width: 160px;
  margin: 8px 0px;
}

.footer-bottom .about-text {
  display: block;
  margin-right: 10px;
}
.footer-bottom .about-text p {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.59);
  margin-bottom: 20px;
  line-height: 20px;
}
.footer-bottom .about-text a {
  font-size: 16px;
  font-weight: 400;
  text-decoration: underline;
  line-height: 24px;
}
.footer-bottom .about-text a:hover {
  text-decoration: none;
}
.footer-bottom .about-text .housing-txt {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.59);
  line-height: 20px;
  text-transform: uppercase;
  margin: 0;
  display: flex;
  align-items: center;
}
.footer-bottom .about-text .housing-txt img {
  margin-right: 16px;
}
.footer-bottom .copy-text {
  display: block;
}
.footer-bottom .copy-text p {
  font-size: 16px;
  line-height: 20px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.59);
  margin: 0 0 20px 0;
}

.footer-bottom ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
  display: block !important;
}
.footer-bottom ul li {
  display: block;
  line-height: 24px;
  margin: 0;
}
.footer-bottom ul li a {
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.59);
  margin-bottom: 10px;
}
.footer-bottom ul li a:hover {
  color: #4cb8ac;
}
.footer-bottom ul li p {
  display: block;
  font-size: 16px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.59);
  margin-bottom: 10px;
}

.social-list li a .ico {
  height: 24px;
  width: 24px;
  display: inline-block;
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.59);
  background-color: rgba(255, 255, 255, 0.1);
  margin-right: 10px;
  border-radius: 50%;
  text-align: center;
  line-height: 26px;
  font-size: 14px;
}
.social-list li a:hover .ico {
  background-color: rgba(76, 184, 172, 0.2);
  color: #fff;
}

.contact-list li {
  margin-bottom: 15px;
}
.contact-list li a {
  position: relative;
  padding-left: 30px;
  padding-right: 30px;
}
.contact-list li a svg {
  margin-right: 10px;
  position: absolute;
  left: 0px;
  top: 3px;
}
.contact-list li a:hover svg {
  fill: #4cb8ac;
}

.comingSoonModel {
  padding: 100px 0px;
  text-align: center;
}
.comingSoonModel i {
  margin-bottom: 40px;
  font-size: 60px;
  color: #4cb8ac;
}
.comingSoonModel h1 {
  letter-spacing: 17px;
  color: #505050;
  font-size: 36px;
  font-weight: 500;
}
.comingSoonModel p {
  font-size: 16px;
  font-weight: normal;
}

@media (max-width: 991px) {
  .footer-section {
    padding: 0px 20px 80px 20px;
  }
  .footer-section .footer-listing {
    padding: 0 10px;
  }
  .footer-section .footer-listing .ant-menu .ant-menu-submenu .ant-menu-submenu-title {
    border: none;
  }
  .footer-section .footer-listing .footer_toggle_options [nz-col] {
    padding: 36px 0;
  }
  .footer-section .footer-listing [nz-col] {
    width: 100%;
    padding: 40px 0px;
    text-align: center;
    border-bottom: 1px solid #566075;
  }
  .footer-bottom h4 {
    margin: 24px 0;
  }
  .footer-bottom .about-text {
    margin: 20px 0 0 0;
  }
  .footer-bottom .app-col .app-col-inn {
    margin: 28px 0 0 0;
  }
}
@media (max-width: 480px) {
  .footer-x-space {
    padding: 0px 0px;
  }
  .footer-top {
    text-align: center;
    padding: 60px 40px;
  }
  .footer-top .line-heading h4 {
    font-size: 24px;
  }
  .footer-top .line-heading p {
    font-size: 16px;
    padding: 0px 40px;
  }
  .footer-top .ant-btn {
    float: none;
    width: 100%;
  }
  .footer-section {
    padding: 0px 0px 40px 0px;
  }
  .footer-section .footer-listing {
    padding: 0 10px;
  }
  .footer-section .footer-listing [nz-col] {
    width: 100%;
    padding: 40px 0px;
    text-align: center;
    border-bottom: 1px solid #566075;
  }
  .footer-section .footer_toggle_options [nz-col] {
    padding: 40px 10px !important;
    text-align: left;
  }
  .footer-section .footer-bottom h4 {
    margin: 20px 0px 20px 0;
  }
  .footer-section .footer-bottom ul li a {
    margin: 0px 0 18px 0px !important;
  }
  .footer-section .footer-bottom .about-text a.last {
    margin-bottom: 20px;
  }
  .footer-section .footer-bottom .housing-txt {
    margin-bottom: 20px;
  }
  .footer-section .footer-bottom .footer-logo {
    margin-bottom: 40px;
  }
  .footer-section .footer-bottom .footer-logo img {
    height: 40px;
    width: auto;
  }
  .footer-section .footer-bottom [nz-row] {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .footer-section .footer-bottom .app-col .app-col-inn {
    margin: 0;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    margin-top: 28px;
  }
  .footer-section .footer-bottom .app-col .app-col-inn h4 {
    font-size: 20px;
    line-height: 23px;
    margin-bottom: 24px;
  }
  .footer-section .footer-bottom .app-col .app-col-inn .app-icon {
    display: flex;
    flex-direction: column;
  }
  .footer-section .footer-bottom .app-col .app-col-inn .app-icon img {
    width: 156px;
    height: auto;
    margin-top: 13px;
  }
  .footer-section .footer-bottom .app-col .app-col-inn .app-icon a:first-child img {
    margin-top: 0;
  }
  .footer-section .footer-bottom .app-col p {
    padding-right: 200px;
    font-size: 16px;
  }
  .footer-section .footer-bottom .app-col img {
    width: 154px;
  }
  .footer-section .footer-bottom .app-col .copy-text {
    margin-top: 25px;
  }
  .footer-section .footer-bottom .app-col .copy-text p {
    padding: 0;
    font-size: 14px !important;
    line-height: 22px;
    margin: 0px;
  }
  .comingSoonModel {
    padding: 0px;
  }
  .comingSoonModel i {
    margin-bottom: 20px;
  }
  .comingSoonModel h1 {
    letter-spacing: 5px;
    font-size: 26px;
  }
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/layout/components/footer/footer.component.scss"],"names":[],"mappings":"AAAA,8EAAA;AAQA,0BAAA;ACNA;EACE,mBDqCU;ECpCV,yBAAA;AAEF;AADE;EACE,gCAAA;EACA,mBAAA;AAGJ;AAFI;EACE,0BAAA;AAIN;AAAM;EAEE,yBAAA;AACR;;AAIA;EACE,iBAAA;EACA,yBDRQ;ACOV;AAGE;EACE,kBAAA;AADJ;AAGI;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,WDnBE;ECoBF,cAAA;EACA,iBAAA;AADN;AAEM;EACE,gBAAA;AAAR;AAGI;EACE,WD3BE;EC4BF,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AADN;AAIE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cDrCM;ECsCN,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;AAFJ;AAII;EACE,yBDjDI;ECkDJ,WDpDE;ECqDF,kBDrDE;ACmDR;;AAMA;EACE,kBAAA;AAHF;;AASE;EACE,cAAA;EACA,mBAAA;AANJ;AAQI;EACE,cAAA;EACA,YAAA;EACA,YAAA;AANN;AAUE;EACE,eAAA;EACA,gBAAA;EACA,WD9EI;EC+EJ,mBAAA;AARJ;AAWI;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AATN;AAUM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;AARR;AAWQ;EACE,kBAAA;EACA,YAAA;AATV;AAUU;EACE,SAAA;AARZ;AAaI;EACE,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;EACA,8BAAA;AAXN;AAaI;EACE,YAAA;EACA,eAAA;AAXN;;AAiBE;EACE,cAAA;EAEA,kBAAA;AAfJ;AAiBI;EACE,eAAA;EACA,gBAAA;EACA,gCDvGY;ECwGZ,mBAAA;EACA,iBAAA;AAfN;AAiBI;EACE,eAAA;EACA,gBAAA;EAEA,0BAAA;EACA,iBAAA;AAhBN;AAiBM;EACE,qBAAA;AAfR;AAqBI;EACE,eAAA;EACA,gBAAA;EACA,gCD3HY;EC4HZ,iBAAA;EACA,yBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAnBN;AAoBM;EACE,kBAAA;AAlBR;AAsBE;EACE,cAAA;AApBJ;AAuBI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCD9IY;EC+IZ,kBAAA;AArBN;;AA2BE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAxBJ;AA0BI;EACE,cAAA;EACA,iBAAA;EACA,SAAA;AAxBN;AAyBM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gCDnKU;ECoKV,mBAAA;AAvBR;AAyBQ;EACE,cDlMA;AC2KV;AA2BM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gCD/KU;ECgLV,mBAAA;AAzBR;;AAkCM;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCD9LU;EC+LV,0CAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA/BR;AAkCQ;EACE,yCAAA;EACA,WDtOF;ACsMR;;AAwCE;EACE,mBAAA;AArCJ;AAsCI;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;AApCN;AAqCM;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAnCR;AAsCQ;EACE,aD1PA;ACsNV;;AA2CA;EAEE,kBAAA;EACA,kBAAA;AAzCF;AA2CE;EACE,mBAAA;EACA,eAAA;EACA,cDzQM;ACgOV;AA2CE;EACE,oBAAA;EACA,cAAA;EAEA,eAAA;EACA,gBAAA;AA1CJ;AA4CE;EACE,eAAA;EACA,mBAAA;AA1CJ;;AA+CA;EACE;IACE,2BAAA;EA5CF;EA6CE;IACE,eAAA;EA3CJ;EA8CQ;IACE,YAAA;EA5CV;EAiDM;IACE,eAAA;EA/CR;EAkDI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gCAAA;EAhDN;EAqDE;IACE,cAAA;EAnDJ;EAqDE;IACE,kBAAA;EAnDJ;EAsDI;IACE,kBAAA;EApDN;AACF;AAyDE;EACA;IACE,gBAAA;EAvDF;EAyDA;IACE,kBAAA;IACA,kBAAA;EAvDF;EAyDI;IACE,eAAA;EAvDN;EAyDI;IACE,eAAA;IACA,iBAAA;EAvDN;EA0DE;IACE,WAAA;IACA,WAAA;EAxDJ;EA2DA;IACE,yBAAA;EAzDF;EA0DE;IACE,eAAA;EAxDJ;EAyDI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gCAAA;EAvDN;EA2DI;IACE,6BAAA;IACA,gBAAA;EAzDN;EA6DI;IAEE,uBAAA;EA5DN;EAgEQ;IAEE,iCAAA;EA/DV;EAoEM;IACE,mBAAA;EAlER;EAqEI;IACE,mBAAA;EAnEN;EAqEI;IACE,mBAAA;EAnEN;EAoEM;IACE,YAAA;IACA,WAAA;EAlER;EAqEI;IACE,2BAAA;IACA,4BAAA;EAnEN;EAyEM;IACE,SAAA;IACA,sBAAA;IACA,uBAAA;IACA,aAAA;IACA,gBAAA;EAvER;EAwEQ;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;EAtEV;EAwEQ;IACE,aAAA;IACA,sBAAA;EAtEV;EAuEU;IACE,YAAA;IACA,YAAA;IACA,gBAAA;EArEZ;EAyEc;IACE,aAAA;EAvEhB;EA6EM;IACE,oBAAA;IACA,eAAA;EA3ER;EA6EM;IACE,YAAA;EA3ER;EA8EM;IAAW,gBAAA;EA3EjB;EA4EQ;IACE,UAAA;IACA,0BAAA;IACA,iBAAA;IACA,WAAA;EA1EV;EAiFA;IACE,YAAA;EA/EF;EAgFE;IACE,mBAAA;EA9EJ;EAgFE;IACE,mBAAA;IACA,eAAA;EA9EJ;AACF","sourcesContent":["/* You can add global styles to this file, and also import other style files */\n$import-theme-font: Roboto;\n\n@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');\n\n$base-font: 'Roboto', sans-serif;\n$heading-font: 'Roboto', sans-serif;\n\n/*** Color Variables *****/\n$dark: #13192d;\n$light: #f9f9f9;\n$light-gray: #eff4f5;\n$white: #fff;\n$black: #000000;\n$primary: #4cb8ac;\n$light-primary: #dff7f9;\n$clight-primary: #e3fbf8;\n$xlight-primary: #f5fbfc;\n$primary-hover: #4cb8ac;\n$secondary: #4179bd;\n$secondary-hover: #3a6daa;\n$placeholder-color: #b7b9c1;\n$alert: #d0031c;\n$pending: #ff7a0a;\n$close: #1f60c3;\n$red: #d0031c;\n$success-green: #52c41a;\n$blue: #0053af;\n$light-blue: #f2fffe;\n$error:#ff4d4f;\n$primary-ghost: #e4f8f9;\n\n$top-nav-color: none;\n$dark-text-clr: #13171f;\n$gray-text-clr: #656c78;\n$gray-text-clr-1: #616b7d;\n$mgray-text-clr: #7e828c;\n$mgray-text-clr-1: #7d8494;\n$lgray-text-clr: #acb2be;\n// $footer-bg: #2f3b3d;\n$footer-bg: #0c1a38;\n$footer-text-clr: rgba(255, 255, 255, 0.59);\n\n$left-nav-clr: #12161f;\n$left-nav-icon: #515b72;\n\n$input-bg: #fcfcfc;\n$input-b-clr: #e8e8e8;\n$input-br-clr: #ccd8db;\n$input-lbl-clr: #566074;\n$checkbox-txt-clr: #5f636c;\n\n$modal-h-clr: #3b414d;\n$detail-bg: #fcfbfb;\n\n$google: #db4437;\n$facebook: #3b5998;\n\n$mail-clr: #4cb8ac;\n$fb-clr: #475993;\n$twt-clr: #03a9f4;\n$in-clr: #0077b7;\n\n$forsale-bg: #dff7f9;\n$forsale-clr: #4cb8ac;\n$salepending-bg: #fff2dc;\n$salepending-clr: #f5a623;\n$contingent-bg: #f1e7ff;\n$contingent-clr: #bb8eff;\n$sold-bg: #ffebee;\n$sold-clr: #eb6777;\n$withdrawn-bg: #fff0e2;\n$withdrawn-clr: #b78151;\n$inreview-bg: #E2EFFF;\n$inreview-clr: #4A90E2;\n$for-rent-bg: #e2efff;\n$for-rent-clr: #4a90e2;\n$offer-pending-clr: #efa92b;\n$offer-pending-bg: #fdf8ed;\n$offer-accepted-clr: #4cb8ac;\n$offer-accepted-bg: #edf7f6;\n\n$primary-color: #3a7ca5;\n$secondary-color: #4cb8ac;\n$background-color: #f4f4f8;\n$text-color: #333;\n$border-color: #e0e0e0;\n$disable-color: #a0a0a0;\n\n$primary-teal: #4CB8AC;\n$primary-teal-hover: #3da396;\n$text-white: white;\n$font-family: 'Roboto', sans-serif;\n$dark-bg: #12161F;\n\n$line-through-text-clr: #71747E;","@use 'variables.scss' as *;\n\n.footer-section {\n  background: $footer-bg;\n  padding: 0px 0px 80px 0px;\n  .footer-listing {\n    border-bottom: 1px solid #566075;\n    margin-bottom: 60px;\n    [nz-col] {\n      padding: 36px 0px 36px 0px;\n      // padding: 36px 0px 0px 0px;\n    }\n    .footer_toggle_options{\n      [nz-col] {\n        // padding: 36px 0px 36px 0px;\n        padding: 0px 0px 36px 0px;\n      }\n    }\n  }\n}\n.footer-top {\n  padding: 80px 0px;\n  background-color: $primary;\n\n  .line-heading {\n    position: relative;\n\n    h4 {\n      font-size: 26px;\n      font-weight: 300;\n      margin: 0px 0px 10px 0px;\n      color: $white;\n      display: block;\n      line-height: 39px;\n      span {\n        font-weight: 500;\n      }\n    }\n    p {\n      color: $white;\n      font-size: 18px;\n      font-weight: 300;\n      letter-spacing: -0.23px;\n      margin-bottom: 0px;\n      line-height: 27px;\n    }\n  }\n  .ant-btn {\n    float: right;\n    font-size: 14px;\n    font-weight: 600;\n    color: $primary;\n    text-align: center;\n    letter-spacing: 1px;\n    padding: 12px 55px;\n    height: auto;\n    border-radius: 35px;\n    margin-top: 15px;\n    text-transform: uppercase;\n    border-color: transparent;\n    line-height: 22px;\n\n    &:hover {\n      background-color: $primary;\n      color: $white;\n      border-color: $white;\n    }\n  }\n}\n.footer-x-space{\n  padding: 0px 100px;\n}\n\n\n\n.footer-bottom {\n  .footer-logo {\n    display: block;\n    margin-bottom: 40px;\n\n    img {\n      display: block;\n      width: 126px;\n      height: auto;\n    }\n  }\n\n  h4 {\n    font-size: 20px;\n    font-weight: 600;\n    color: $white;\n    margin-bottom: 42px;\n  }\n  .app-col {\n    .app-col-inn{\n      border: 1px solid #566075;\n      padding: 32px 40px;\n      border-radius: 4px;\n      display:flex;\n      flex-direction:row;\n      align-items: center;\n      justify-content: space-between;\n      margin-top: -70px;\n      h4{\n        font-size:20px;\n        line-height:48px;\n        font-weight: 500;\n        margin:0;\n        text-transform: uppercase;\n      }\n      .app-icon{\n        img{\n          margin:0 0 0 16px;\n          height:48px;\n          &:first-child{\n            margin:0;\n          }\n        }\n      }\n    }\n    p {\n      font-size: 18px !important;\n      font-weight: 300;\n      line-height: 1.33;\n      color: rgba(255, 255, 255, 0.59);\n      padding-right: 50px;\n      margin-bottom: 16px !important;\n    }\n    img {\n      width: 160px;\n      margin: 8px 0px;\n    }\n  }\n}\n\n.footer-bottom {\n  .about-text {\n    display: block;\n    // width: 220px;\n    margin-right:10px;\n\n    p {\n      font-size: 16px;\n      font-weight: 400;\n      color: $footer-text-clr;\n      margin-bottom: 20px;\n      line-height: 20px;\n    }\n    a {\n      font-size: 16px;\n      font-weight: 400;\n      // display: block;\n      text-decoration:underline;\n      line-height: 24px;\n      &:hover{\n        text-decoration: none;\n      }\n    }\n    a.last {\n      // margin-bottom: 40px;\n    }\n    .housing-txt{\n      font-size: 16px;\n      font-weight: 400;\n      color: $footer-text-clr;\n      line-height: 20px;\n      text-transform: uppercase;\n      margin: 0; \n      display: flex;\n      align-items: center;\n      img{\n        margin-right:16px;\n      }\n    }\n  }\n  .copy-text {\n    display: block;\n    // width: 220px;\n\n    p {\n      font-size: 16px;\n      line-height: 20px;\n      font-weight: 300;\n      color: $footer-text-clr;\n      margin: 0 0 20px 0;\n    }\n  }\n}\n\n.footer-bottom {\n  ul {\n    list-style: none;\n    margin: 0px;\n    padding: 0px;\n    display: block !important;\n\n    li {\n      display: block;\n      line-height: 24px;\n      margin:0;\n      a {\n        display: block;\n        font-size: 16px;\n        font-weight: 400;\n        color: $footer-text-clr;\n        margin-bottom: 10px;\n\n        &:hover {\n          color: $primary;\n        }\n      }\n\n      p {\n        display: block;\n        font-size: 16px;\n        font-weight: 300;\n        color: $footer-text-clr;\n        margin-bottom: 10px;\n      }\n    }\n  }\n}\n\n.social-list {\n  li {\n    a {\n      .ico {\n        height: 24px;\n        width: 24px;\n        display: inline-block;\n        vertical-align: middle;\n        color: $footer-text-clr;\n        background-color: rgba(255, 255, 255, 0.1);\n        margin-right: 10px;\n        border-radius: 50%;\n        text-align: center;\n        line-height: 26px;\n        font-size: 14px;\n      }\n      &:hover {\n        .ico {\n          background-color: rgba(76, 184, 172, 0.2);\n          color: $white;\n        }\n      }\n    }\n  }\n}\n\n.contact-list {\n  li {\n    margin-bottom: 15px;\n    a {\n      position: relative;\n      padding-left: 30px;\n      padding-right: 30px;\n      svg {\n        margin-right: 10px;\n        position: absolute;\n        left: 0px;\n        top: 3px;\n      }\n      &:hover {\n        svg {\n          fill: $primary;\n        }\n      }\n    }\n  }\n}\n\n.comingSoonModel {\n  // padding: 100px 150px;\n  padding: 100px 0px;\n  text-align: center;\n\n  i {\n    margin-bottom: 40px;\n    font-size: 60px;\n    color: $primary;\n  }\n  h1 {\n    letter-spacing: 17px;\n    color: #505050;\n    // margin-bottom: 40px;\n    font-size: 36px;\n    font-weight: 500;\n  }\n  p {\n    font-size: 16px;\n    font-weight: normal;\n  }\n}\n\n\n@media (max-width: 991px) {\n  .footer-section{\n    padding: 0px 20px 80px 20px; \n    .footer-listing {\n      padding: 0 10px;\n      .ant-menu{\n        .ant-menu-submenu{\n          .ant-menu-submenu-title{\n            border:none; \n          }\n        }\n      }\n      .footer_toggle_options{\n        [nz-col] {\n          padding:36px 0;\n        }\n      }\n      [nz-col] {\n        width: 100%;\n        padding: 40px 0px;\n        text-align: center;\n        border-bottom: 1px solid #566075;\n      }  \n    }\n  } \n  .footer-bottom{\n    h4{\n      margin: 24px 0;\n    }\n    .about-text{\n      margin:20px 0 0 0;\n    }\n    .app-col{\n      .app-col-inn{\n        margin:28px 0 0 0;\n      }\n    }\n  }\n}\n\n  @media (max-width: 480px) {\n  .footer-x-space{\n    padding: 0px 0px;\n  }\n  .footer-top {\n    text-align: center;\n    padding: 60px 40px;\n    .line-heading {\n      h4 {\n        font-size: 24px;\n      }\n      p {\n        font-size: 16px;\n        padding: 0px 40px;\n      }\n    }\n    .ant-btn {\n      float: none;\n      width: 100%;\n    }\n  }\n  .footer-section {\n    padding: 0px 0px 40px 0px;\n    .footer-listing {\n      padding: 0 10px;\n      [nz-col] {\n        width: 100%;\n        padding: 40px 0px;\n        text-align: center;\n        border-bottom: 1px solid #566075;\n      }\n    }\n    .footer_toggle_options{\n      [nz-col] { \n        padding:40px 10px!important;\n        text-align: left;\n      }\n    }\n    .footer-bottom {\n      h4 {\n        // margin-bottom: 20px;\n        margin: 20px 0px 20px 0;\n      }\n      ul {\n        li {\n          a {\n            // padding-right: 100px;\n            margin: 0px 0 18px 0px !important;\n          }\n        }\n      }\n      .about-text {\n        a.last {\n          margin-bottom: 20px;\n        }\n      }\n      .housing-txt{\n        margin-bottom:20px;\n      }\n      .footer-logo {\n        margin-bottom: 40px;\n        img {\n          height: 40px;\n          width: auto;\n        }\n      }\n      [nz-row] {\n        margin-left: 0px !important;\n        margin-right: 0px !important;\n        [nz-col] {\n          // margin-bottom: 20px;\n        }\n      }\n      .app-col {\n        .app-col-inn{\n          margin: 0;\n          flex-direction: column;\n          align-items: flex-start;\n          padding: 20px;\n          margin-top: 28px;\n          h4{\n            font-size: 20px;\n            line-height:23px;\n            margin-bottom:24px;\n          }\n          .app-icon{ \n            display: flex;\n            flex-direction: column;\n            img{\n              width:156px;\n              height:auto;\n              margin-top: 13px; \n            } \n            a{\n              &:first-child {\n                img{\n                  margin-top: 0;\n                }\n              }\n            }\n          }\n        }\n        p {\n          padding-right: 200px;\n          font-size: 16px;\n        }\n        img {\n          width: 154px;\n        }\n\n        .copy-text{margin-top: 25px;\n          p{\n            padding: 0;\n            font-size: 14px !important;\n            line-height: 22px;\n            margin: 0px;\n          }\n        }\n      }\n\n    }\n  }\n  .comingSoonModel{\n    padding:0px;  \n    i { \n      margin-bottom: 20px;\n    }\n    h1 {\n      letter-spacing: 5px; \n      font-size: 26px; \n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
